export default {
  "content": "<path d=\"M480-96q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30.5-150T209-752l51 51q-42 42-67 99t-25 122q0 130 91 221t221 91q130 0 221-91t91-221q0-65-24-122t-67-99l51-51q53 52 82.5 122T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96zm-36-336v-432h72v432h-72z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 -960 960 960",
    "fill": "currentColor"
  }
};